export function isValidEmailFormat(email: string): boolean {
  const matches = email.toLowerCase().match(
    // eslint-disable-next-line no-control-regex
    /(?:[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/g
  );
  return (
    matches !== null &&
    matches.length === 1 &&
    email.length === matches[0].length
  );
}

export const isValidIpV4 = (ip: string): boolean =>
  /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
    ip
  );

export const getMaxValidExpirationDate = (maxDays: number = 60): Date => {
  const n = new Date();
  n.setHours(23, 59, 59, 999);
  return new Date(n.setDate(n.getDate() + maxDays));
};

export const isValidExpirationDate = (val: Date): boolean => {
  if (!(val instanceof Date) || val.toString() === "Invalid Date") return false;

  let min = new Date();
  min.setHours(0, 0, 0, 0);
  let max = getMaxValidExpirationDate();

  if (val < min || val > max) return false;

  return true;
};

export const getFileNameExtension = (filename: string): string => {
  const match = filename.match(/[^\\]*\.(\w+)|.*$/);
  return match!.length >= 2 ? match![1] : "";
};
